import { Routes, Route, Navigate } from 'react-router';
import { AdminSignIn, TenantSignIn } from '@/pages/auth/signin';
import { PartnerAuthPage } from '@/pages/auth/partner-auth';
import { LandingPage } from '@/pages/landing';
import { ProtectedDashboard } from '@/routes/protected-dashboard';
import { AdminAdminsPage } from '@/pages/dashboard/admin/admins';
import { AdminAdminsForm } from '@/pages/dashboard/admin/admins/form';
import { AdminUsersPage } from '@/pages/dashboard/admin/users';
import { AdminUsersForm } from '@/pages/dashboard/admin/users/form';
import { AdminTenantsPage } from '@/pages/dashboard/admin/tenants';
import { AdminTenantsForm } from '@/pages/dashboard/admin/tenants/form';
import { AdminTenantDetailsPage } from '@/pages/dashboard/admin/tenants/[slug]';
import { AdminTenantExtensionPage } from '@/pages/dashboard/admin/tenants/[slug]/extensions/[extensionName]';
import { DashboardIndex } from '@/pages/dashboard';
import { BuildHistoryPage } from '@/pages/dashboard/tenant/build-history';
import { TenantAssetsPage } from '@/pages/dashboard/tenant/assets';
import { SettingsPage } from '@/pages/dashboard/tenant/settings';
import { CollectionDataPage } from '@/pages/dashboard/tenant/collections/[collectionName]';
import { FormSubmissionsPage } from '@/pages/dashboard/tenant/forms/[endpoint]';
import { TenantExtensionPage } from '@/pages/dashboard/tenant/extensions/[extensionName]';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/admin" element={<Navigate to="/admin/signin" />} />
      <Route path="/admin/signin" element={<AdminSignIn />} />
      <Route path="/signin" element={<TenantSignIn />} />
      <Route path="/partners/:tenantSlug/signin" element={<PartnerAuthPage />} />

      <Route path="/admin/dashboard" element={<ProtectedDashboard userType="admin" />}>
        <Route index element={<DashboardIndex />} />
        <Route path="admins">
          <Route index element={<AdminAdminsPage />} />
          <Route path="create" element={<AdminAdminsForm type="create" />} />
          <Route path=":id/edit" element={<AdminAdminsForm type="edit" />} />
        </Route>
        <Route path="users">
          <Route index element={<AdminUsersPage />} />
          <Route path="create" element={<AdminUsersForm type="create" />} />
          <Route path=":id/edit" element={<AdminUsersForm type="edit" />} />
        </Route>
        <Route path="tenants">
          <Route index element={<AdminTenantsPage />} />
          <Route path="create" element={<AdminTenantsForm type="create" />} />
          <Route path=":id/edit" element={<AdminTenantsForm type="edit" />} />
          <Route path=":slug/extensions/:extensionName" element={<AdminTenantExtensionPage />} />
          <Route path=":slug" element={<AdminTenantDetailsPage />} />
        </Route>
      </Route>

      <Route path="/tenant/dashboard" element={<ProtectedDashboard userType="tenant" />}>
        <Route index element={<DashboardIndex />} />
        <Route path="assets" element={<TenantAssetsPage />} />
        <Route path="build-history" element={<BuildHistoryPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="collections/:collectionName" element={<CollectionDataPage />} />
        <Route path="collections/:collectionName/create" element={<CollectionDataPage />} />
        <Route path="collections/:collectionName/:collection_item_id/edit" element={<CollectionDataPage />} />
        <Route path="forms/:endpoint" element={<FormSubmissionsPage />} />
        <Route path="forms/:endpoint/create" element={<FormSubmissionsPage />} />
        <Route path="forms/:endpoint/:submission_id/edit" element={<FormSubmissionsPage />} />
        <Route path="extensions/:extensionName" element={<TenantExtensionPage />} />
      </Route>

      {/* Public landing page */}
      <Route path="/" element={<LandingPage />} />
      
      {/* Catch-all Not Found Route */}
      <Route path="*" element={
        <div className="flex items-center justify-center min-h-screen bg-background">
          <div className="max-w-md w-full p-6 bg-white rounded-lg shadow-md flex flex-col items-center">
            <h1 className="text-4xl font-bold mb-2">404</h1>
            <p className="text-lg mb-4 text-muted-foreground">Page not found.</p>
            <a href="/" className="text-primary underline">
              Go to Home
            </a>
          </div>
        </div>
      } />
    </Routes>
  );
}
